
export class NotificationContainer {
  private data;
  private size;

  constructor(data: any) {
    if (data && Array.isArray(data) && data.length > 0) {
      this.data = data;
      this.clean();
      this.size = data.length;
    } else {
      this.data = undefined;
      this.size = -1;
    }
  }

  clean() {
    var dismissedItems: number[] = [];
    for (let index = 0; index < this.data.length; index++) {
      let value = localStorage.getItem(this.data[index].messageKey);
      if (value != null) {
        if (!this.isExpired(value)) {
          dismissedItems.push(index);
        } else {
          localStorage.removeItem(this.data[index].messageKey);
        }
      }
    }
    if (dismissedItems.length > 0) {
      for (let index = dismissedItems.length - 1; index >=0; index--) {
        this.data.splice(dismissedItems[index], 1);
      }
    }
  }

  isExpired(dimissedTimestamp: string) {
    let dimissedTimeObj = JSON.parse(dimissedTimestamp);
    const endingTime = new Date(dimissedTimeObj.endDate).getTime();
    const currentTime = new Date().getTime();
    if (currentTime > endingTime) {
      return true;
    } else {
      return false;
    }
  }

  getNotification(index: number) {
    if (index <= this.data.length) {
      return this.data[index];
    } else {
        return undefined;
    }
  }

  getSize() {
    return this.size;
  }
}
